import event, {EVENTS} from '../lib/event';
import {getBlockById, blocksInfo} from "./blocks";
import bindAll from "lodash.bindall";
import {isDropdownType, parseTranslate, useTouchInteraction} from "./utils";
import {getNodeInCodeWorkspace, getNodeInToolbox} from "./highlight";
import {isRectNear} from "../lib/utils";

let instance = null;
class StepRecorder {
    constructor() {
        bindAll(this, [
            'onCreate',
            'onChange',
            'onChangeFinish',
            'onEndDragAndMove',
            'onDelete',
            'onSwitchGroup',
            'onUI',
            'onVarCreate',
            'onSwitchSprite',
            'onSwitchToBg',
        ]);
    }
    startRecordAction(onNewAction) {
        this.stopRecordAction();
        this.onNewAction = onNewAction;
        this.blocksMap = new Map();
        event.addListener("create", this.onCreate);
        event.addListener('change', this.onChange);
        event.addListener(EVENTS.END_DRAG_AND_MOVE, this.onEndDragAndMove);
        event.addListener('delete', this.onDelete);
        event.addListener('ui', this.onUI);
        event.addListener('var_create', this.onVarCreate);

        this.toolbox = document.querySelector('.blocklyToolboxDiv');

        document.querySelectorAll('div[class^="sprite-selector_sprite-wrapper"]').forEach(node=>{
            node.addEventListener('click', this.onSwitchSprite, true);
        });
        document.querySelector('[class^="target-pane_stage-selector-wrapper"]').addEventListener('click', this.onSwitchToBg, true);
        /*
        if (useTouchInteraction) {
            this.toolbox.addEventListener('touchend', this.onSwitchGroup, true);
        } else {
            this.toolbox.addEventListener('mouseup', this.onSwitchGroup, true);
        }*/
    }

    stopRecordAction() {
        event.removeListener("create", this.onCreate);
        event.removeListener('change', this.onChange);
        event.removeListener(EVENTS.END_DRAG_AND_MOVE, this.onEndDragAndMove);
        event.removeListener('delete', this.onDelete);
        event.removeListener('ui', this.onUI);
        event.removeListener('var_create', this.onVarCreate);

        if (this.toolbox) {
            /*
            if (useTouchInteraction) {
                this.toolbox.removeEventListener('touchend', this.onSwitchGroup, true);
            } else {
                this.toolbox.removeEventListener('mouseup', this.onSwitchGroup, true);
            }*/
            this.toolbox = undefined;
        }

        document.querySelectorAll('div[class^="sprite-selector_sprite-wrapper"]').forEach(node=>{
            node.removeEventListener('click', this.onSwitchSprite, true);
        });
        document.querySelector('[class^="target-pane_stage-selector-wrapper"]').removeEventListener('click', this.onSwitchToBg, true);
    }

    static get instance() {
        if (!instance) instance = new StepRecorder();
        return instance;
    }

    static startRecordAction(onNewAction) {
        StepRecorder.instance.startRecordAction(onNewAction);
    }

    static stopRecordAction() {
        StepRecorder.instance.stopRecordAction();
    }

    static record(isAppend) {
        if (!isAppend) {
            window.actions = [];
            window.steps = [];
        }
        StepRecorder.instance.startRecordAction(action => {
            window.actions.push(action);
        })
    }

    /**
     * 创建一个新的step，并且清空之前的steps
     * @param params step的相关属性
     */
    static newStep(params) {
        if (window.actions.length > 0) {
            //之前的步骤没有保存的情况，自动保存一个默认的
            if (window.steps.length === 0) {
                window.steps.push({
                    tips: '自动保存的步骤',
                    actions: window.actions
                });
            }
            window.actions = [];
        }
        window.steps.push({
            ...params,
            actions: window.actions
        })
    }

    onCreate(e) {
        this.createBlock = e.blockId;
        this.selectedBlockIdBeforeCreate = this.selectedBlockId;
        setTimeout(()=>{
            const block = getBlockById(e.blockId);
            if (block && block.opcode === "procedures_definition") { //创建了自定义积木
                const prototypeBlock = getBlockById(block.inputs.custom_block.block);
                let action = {
                    action: 'createCustomProcedure',
                    params: {
                        id: e.blockId,
                        proccode: prototypeBlock.mutation.proccode,

                    }
                };
                const ids = JSON.parse(prototypeBlock.mutation.argumentids);
                if (ids.length > 0) {
                    action.params.argumentnames = JSON.parse(prototypeBlock.mutation.argumentnames);
                    action.params.argumentids = [];
                    for (let i = 0; i < ids.length; ++i) {
                        action.params.argumentids.push(prototypeBlock.inputs[ids[i]].block);
                    }
                }
                this.onNewAction(action);
            }
        }, 200);

    }

    onUI(e) {
        if (this.changeEvent) {
            this.onChangeFinish(this.changeEvent);
            this.changeEvent = undefined;
        }
        if (e.element === 'selected') {
            this.selectedBlockId = e.newValue;
            if (e.newValue) {
                this.lastSelectedBlockId = e.newValue;
            }
        }
    }

    onChange(e) {
        if (this.changeEvent && this.changeEvent.blockId !== e.blockId) { //多个输入框之间直接切换
            this.onChangeFinish(this.changeEvent);
            this.changeEvent = undefined;
        }
        let node = document.querySelectorAll(".blocklyWorkspace")[0].querySelector(`[data-id="${e.blockId}"]`);
        if (e.element === 'field') {
            let t = document.querySelectorAll(".blocklyWorkspace")[0].querySelector(`[data-id="${e.blockId}"]>[data-argument-type]:not([data-id])`);
            if (t) node = t;
        }
        if (node && isDropdownType(node.getAttribute('data-argument-type'))) {
            this.onChangeFinish(e)
        }else { //类似输入框这样的修改过程，不立即记录，直到触发ui事件
            this.changeEvent = e;
        }
    }

    async onChangeFinish(e) {
        const blockId = e.blockId;
        let block = getBlockById(blockId);
        let newValue = e.newValue;

        if (block && block.fields) {
            //处理新建广播消息的情况，必须使用block.parent，否则blockId定位的是新创建的消息变量，重新运行的时候还没有创建，就无法定位
            if (e.name === "BROADCAST_OPTION" && this.tobeCreateMessageEvent) {
                if (e.newValue === this.tobeCreateMessageEvent.varId) {
                    this.onNewAction({
                        action: 'createNewMessage',
                        params: {
                            target: {
                                id: block.parent || blockId
                            },
                            name: this.tobeCreateMessageEvent.varName
                        }
                    });
                    this.tobeCreateMessageEvent = undefined;
                    return;
                }
                this.tobeCreateMessageEvent = undefined;
            }


            let foundId = false;
            for (let key in block.fields) {
                if (block.fields[key].id) {
                    foundId = true;
                    break;
                }
            }
            if (foundId) {
                await new Promise(resolve => {
                    let count = 0;
                    const intval = setInterval(() => {
                        ++count;
                        if (count > 10) {
                            clearInterval(intval);
                            resolve();
                        }
                        block = getBlockById(e.blockId);
                        for (let key in block.fields) {
                            if (block.fields[key].id === e.newValue) { //列表选中的目标是变量的情况
                                newValue = block.fields[key].value;
                                clearInterval(intval);
                                resolve();
                                break;
                            }
                        }
                    }, 100);
                });
            }

        }



        console.log(block, newValue);
        let action = {
            action: 'change',
            params: {
                target: {
                    id: blockId,
                },
                name: e.name,
                shadow: block.shadow,
                oldValue: e.oldValue,
                newValue: newValue,
                newValueDisplay: newValue,
            }
        };
        let node = getNodeInCodeWorkspace({id: blockId});
        let isShadow = true;
        if (!node.getAttribute('data-argument-type')) { //其实可以通过block.shadow来判断
            isShadow = false;
            const codeWorkspaceNode = document.querySelectorAll(".blocklyWorkspace")[0];
            //node = codeWorkspaceNode.querySelector(`[data-id="${blockId}"]>[data-argument-type]:not([data-id])`);
            node = codeWorkspaceNode.querySelector(`[data-id="${blockId}"] [data-argument-type][name="${e.name}"]`);
        }
        if (node && isDropdownType(node.getAttribute('data-argument-type'))) {
            action.params.newValueDisplay = node.querySelector('text.blocklyDropdownText').innerHTML.trim();
        }

        //有些输入参数是积木块拖入时动态生成的，当前block是参数本身，并且下一次拖入时id会变，因此要用其parent来定位之。但是如果不具有'data-argument-type'属性的，当前block就是其父块
        //TODO 这里可以考虑在拖入新积木块时，不仅仅将积木块本身的id进行map，对内部所有inputs和fields里的带有id的也都进行map，这样就可以直接通过参数本身的blockid来定位
        if (block.parent && isShadow) {
            action.params.target.id = block.parent;
            const parentBlock = getBlockById(block.parent);
            let i = 0;
            for (let key in parentBlock.inputs) {
                if (parentBlock.inputs[key].block === blockId) {
                    action.params.target.input = key;
                    action.params.target.inputIndex = i;
                    action.params.target.blockInputIndex = i;
                    break;
                }
                ++i;
            }
            if (action.params.target.input == undefined) {
                i = 0;
                for (let key in parentBlock.fields) {
                    if (parentBlock.fields[key].block === blockId) {
                        action.params.target.field = key;
                        action.params.target.fieldIndex = i;
                        break;
                    }
                    ++i;
                }
            }
            if (action.params.target.input === undefined && action.params.target.field === undefined) { //如果内部没有找到，说明不在父块内
                action.params.target.id = blockId;
            }
        }

        this.onNewAction(action);
    }

    onEndDragAndMove(e) {
        const blockId = e.blockId;
        this.lastEndDragAndMoveBlock = e.blockId;
        this.blocksMap.set(blockId, true);
        const block = getBlockById(blockId);
        if (!block) {
            console.error('拖动后的block没有找到: ' + blockId + ', 如果是删除操作，忽略这条消息');
            return;
        }
        let parentBlock = null;
        if (block.parent) parentBlock = getBlockById(block.parent);
        let action = {
            params: {
                source: {
                    id: blockId
                },
                target: {

                }
            }
        };
        if (this.createBlock === blockId) { //左侧拖入
            action.action = 'addBlock';
            action.params.source.opcode = block.opcode;
            if (block.opcode === 'data_variable') {
                action.params.source.varName = block.fields.VARIABLE.value;
            }else if (block.opcode === 'procedures_call') {
                action.params.source.proccode = block.mutation.proccode;
            }else if (!getNodeInToolbox(action.params.source)) {
                const selectedBlock = getBlockById(this.selectedBlockIdBeforeCreate);
                if (selectedBlock && selectedBlock.opcode === "procedures_definition") { //来自自定义积木块的参数，需要将source指向参数定义
                    const argNodes = document.querySelectorAll('[data-id="' + selectedBlock.inputs.custom_block.block + '"]>[data-id]');
                    argNodes.forEach((node) => {
                        const argBlock = getBlockById(node.getAttribute('data-id'));
                        if (argBlock && argBlock.opcode === block.opcode && argBlock.fields.VALUE.value === block.fields.VALUE.value) {
                            action.params.source.argId = argBlock.id;
                        }
                    })
                }
            }
        }else { //移动的情况
            action.action = 'dragBlock';
        }
        if (block.parent) {
            action.params.target.id = block.parent;
            //添加到分支的情况
            if (parentBlock.inputs) {
                let i = 0;
                for (let key in parentBlock.inputs) {
                    if (parentBlock.inputs[key].block === blockId) {
                        action.params.target.input = key;
                        if (parentBlock.opcode === 'procedures_call') { //自定义积木块，需要记录参数在block的inputs数组中的序号，用于做校验
                            action.params.target.blockInputIndex = i;
                        }
                        /*
                        if (parentBlock.opcode === 'procedures_call') { //自定义积木块，需要记录参数的序号，focusBlock的时候才能正确定位
                            action.params.target.inputIndex = i;
                        }else {

                         */
                            //inputIndex记录参数的物理序号
                            const blockInfo = blocksInfo[parentBlock.opcode];
                            if (!blockInfo || !blockInfo.inputKeys) {
                                console.warn(parentBlock.opcode + " has no block info");
                                const args = document.querySelectorAll(`[data-id="${parentBlock.id}"]>[data-argument-type]`);
                                if (args && args.length > 0) {
                                    let nodes = [];
                                    for (let j = 0; j < args.length; ++j) {
                                        nodes.push(args[j]);
                                    }
                                    nodes.sort((a, b)=>{
                                        return parseTranslate(a.getAttribute('transform')).x - parseTranslate(b.getAttribute('transform')).x;
                                    });
                                    const blockNode = document.querySelector(`[data-id="${blockId}"]`);
                                    for (let j = 0; j < nodes.length; ++j) {
                                        if (isRectNear(nodes[j].getBoundingClientRect(), blockNode.getBoundingClientRect())) {
                                            action.params.target.inputIndex = j;
                                            break;
                                        }
                                    }
                                    if (action.params.target.inputIndex === undefined) {
                                        console.error(parentBlock, " data-argument-type data-id not found");
                                    }
                                }else {
                                    console.error(parentBlock, " data-argument-type not found");
                                }
                            }else {
                                action.params.target.inputIndex = blockInfo.inputKeys.indexOf(key);
                                if (action.params.target.inputIndex < 0) {
                                    console.error(parentBlock.opcode + " has no field: " + key);
                                    alert(parentBlock.opcode + " has no field: " + key);
                                }
                            }
                        //}
                        break;
                    }
                    ++i;
                }
            }
        }else {
            action.params.target.position = {
                x: block.x,
                y: block.y
            };
        }
        console.log(block);
        this.onNewAction(action);
        this.createBlock = null;
    }

    onDelete(e) {
        if (this.createBlock == e.blockId) return; //没有拖入到代码区直接释放掉的情况不录制
        if (this.lastSelectedBlockId != e.blockId) return; //不是选中后的删除，可能是被其他块拖入挤压掉的，不录制
        this.onNewAction({
            action: 'removeBlock',
            params: {
                id: e.blockId
            }
        });
    }

    onSwitchGroup(e) {
        let el = e.target || e.srcElement;
        let i = -1;
        while (el && el !== this.toolbox && typeof(el.className) == 'string' && el.className !== 'blocklyToolboxDiv') {
            i = el.className.indexOf(' scratchCategoryId-');
            if (el.className && i > 0) {
                break;
            }
            el = el.parentNode;
        }
        if (i > 0 && el.className.indexOf('categorySelected') < 0) {
            let id = el.className.substr(i + 19);
            if (id.indexOf(' ') > 0) {
                id = id.substr(0, id.indexOf(' '));
            }
            this.onNewAction({
                action: 'switchGroup',
                params: {
                    id
                }
            })
        }
    }

    onVarCreate(e) {
        if (e.varType === "broadcast_msg") { //消息
            this.tobeCreateMessageEvent = e;
        }else { //变量或列表
            this.onNewAction({
                action: 'createVar',
                params: {
                    id: e.varId,
                    name: e.varName,
                    type: e.varType,
                    isLocal: e.isLocal
                }
            });
        }

    }

    onSwitchSprite(e) {
        this.stopRecordAction();
        showMessage("角色切换中，录制暂停，请等待2秒，再继续录制");
        setTimeout(()=>{
            this.startRecordAction(this.onNewAction);
        }, 1000);
        let node = e.target;
        while (node && node.getAttribute('class').indexOf('sprite-selector_sprite-wrapper') < 0)
            node = node.parentElement;
        if (node) {
            const match = /order: (\d+);/.exec(node.getAttribute('style'))
            if (match) {
                this.onNewAction({
                    action: 'switchSprite',
                    params: {
                        index: Number(match[1])
                    }
                });
            }
        }
    }

    onSwitchToBg(e) {
        this.stopRecordAction();
        showMessage('正在切换到背景角色，录制暂停，请等待2秒，再继续录制');
        setTimeout(()=>{
            this.startRecordAction(this.onNewAction);
        }, 1000);
        this.onNewAction({
            action: 'switchToBg'
        })

    }

}

window.StepRecorder = StepRecorder;
window.record = StepRecorder.record;
window.stopRecord = StepRecorder.stopRecordAction;
window.newStep = StepRecorder.newStep.bind(StepRecorder);

export default StepRecorder;
